import { render, staticRenderFns } from "./PrizeReceivedModal.vue?vue&type=template&id=09a0a41a&scoped=true&"
import script from "./PrizeReceivedModal.vue?vue&type=script&lang=js&"
export * from "./PrizeReceivedModal.vue?vue&type=script&lang=js&"
import style0 from "./PrizeReceivedModal.vue?vue&type=style&index=0&id=09a0a41a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a0a41a",
  null
  
)

export default component.exports